import { math, em } from 'polished'
import styled, { css } from 'styled-components'

import { Col, Row } from 'styles/components/layout'

const legendFontMd = css`
  font-family: ${p => p.theme.typography.baseFont};
  font-size: ${p => p.theme.typography.cartFontSize};
  line-height: 2.375;
`

export const LegendTitle = styled.h4`
  font-family: ${p => p.theme.typography.mediumFont};
  font-size: ${p => p.theme.typography.textCartLegend};
  line-height: ${p => p.theme.typography.textCartLegendLh};
  font-weight: 400;
  margin-bottom: ${p => em(28, p.theme.typography.textCartLegendPx)};

  ${p => p.theme.mq.upMd} {
    ${legendFontMd};
  }
`

export const LegendItem = styled.h5`
  font-size: ${p => p.theme.typography.textSmallDescr};
  line-height: ${p => p.theme.typography.cartItemFontLh};
  font-weight: 400;
  margin-bottom: ${p => em(17, p.theme.typography.textSmallDescrPx)};

  ${p =>
    p.isLast &&
    css`
      text-align: right;
    `}

  ${p => p.theme.mq.upMd} {
    ${legendFontMd};
    text-align: left;
    margin-bottom: 0;
  }
`

export const RowStyled = styled(Row)`
  margin-top: ${p => math(`${p.theme.blocks.menuHeight} + ${em(33)}`)};

  ${p => p.theme.mq.upMd} {
    margin-top: ${p => math(`${p.theme.blocks.menuHeightMd} + ${em(80)}`)};
  }
`

export const ColStyled = styled(Col)``
